import { Select } from "antd";
import styled from "styled-components";
export const ResourcesWrapper = styled.div`
  .mainWrapperContainer {
    padding: 20px;
  }
  .MainContainer {
    height: 354px;
    height: 328px;
    background: #fff;
    box-shadow: 0px 1px 7.8px 0px rgba(139, 169, 215, 0.2);
    border-radius: 15px;
    min-width: 554px;
    height: 491px;
  }
  .Maincontainer {
    min-height: 524px;
    width: 98%;
    background: #fff;
    box-shadow: 0px 1px 7.8px 0px rgba(139, 169, 215, 0.2);
    border-radius: 15px;
    min-width: 554px;
  }
  .cardHeader {
    display: flex;
    padding: 10px 15px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    border-bottom: 1px solid #c7c7dc99;
    background: ${({ theme }: any) => theme.greyWhite};
    border-radius: 15px 15px 0 0;
  }
  .headerSlider {
    display: flex;
    padding: 4px;
    align-items: center;
    border-radius: 30px;
    border: 1px solid #c7c7dc99;

    margin-left: auto;
  }
  .rightside {
    .downloadContainer {
      display: flex;
      height: 32px;
      padding: 0px 10px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-radius: 8px;
      border: 1px solid ${({ theme }: any) => theme.secondaryGrey};
      background: ${({ theme }: any) => theme.primaryWhite};
      cursor: pointer;
    }
  }
  .box {
    display: flex;
    flex-direction: column;
    padding: 15px;
  }
  .subContainer-1 {
    margin-bottom: 15px;
    padding: 10px;
    align-items: center;
    gap: 15px;
    display: flex;
    flex-direction: row;
    flex: 1 0 0;
    border-radius: 10px;
    border: 1px solid ${({ theme }: any) => theme.secondaryGrey};
  }

  .ant-select-selector {
    border: none !important;
    background: none !important;
    color: ${({ theme }: any) => theme.primaryBlue};
    width: 73px;
    height: 20px;
    box-shadow: none !important;
    :focus-visible {
      outline: none !important;
      box-shadow: none !important;
    }
  }
  .ant-select-selection-item {
    font-size: 12px;
  }
  .uploadContainer {
    display: flex;
    padding: 3px 9px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 30px;
    border: 1px solid ${({ theme }: any) => theme.secondaryGrey};
    height: 31px;
    width: 102px;
    cursor: pointer;
  }
  .uploadText {
    color: ${({ theme }: any) => theme.grayLight};
    text-align: center;
    font-family: Lato;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-transform: uppercase;
    width: 83px;
    height: 15px;
  }
  .fileContainer {
    display: flex;
    padding: 3px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex: 1 0 0;
    border: 1px dashed ${({ theme }: any) => theme.primaryBlue};
    height: 37px;
  }
  .filetext {
    display: flex;
    flex-direction: column;
  }
  .filetext-1 {
    color: ${({ theme }: any) => theme.primaryBlue};
    text-align: center;
    font-size: 13px;
    font-weight: 400;
    line-height: normal;
    text-transform: lowercase;
  }
  .filetext-2 {
    color: ${({ theme }: any) => theme.secondaryGrey};
    text-align: center;

    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-transform: lowercase;
  }
  .subContainer-2 {
    display: flex;
    padding-top: 15px;
    flex-direction: column;
    //align-items: flex-start;
    gap: 10px;
    align-self: stretch;
    border-top: 1px solid ${({ theme }: any) => theme.secondaryGrey};
  }
  .innertext {
    color: ${({ theme }: any) => theme.primaryBlue};
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: uppercase;
  }
  .minisubContainer {
    display: flex;
    flex-direction: row;
  }
  .searchContainer {
    display: flex;
    width: 280px;
    height: 24px;
    padding: 4px 10px;
    justify-content: space-between;
    align-items: center;
    border-radius: 4px;
    border: 1px solid ${({ theme }: any) => theme.primaryGreen};
    background: ${({ theme }: any) => theme.primaryWhite};
  }
  .text-1 {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-right: 15px;
    margin-left: auto;
  }
  .text-2 {
    display: flex;
    padding-left: 15px;
    flex-direction: column;
    align-items: flex-start;
    border-left: 1px solid ${({ theme }: any) => theme.secondaryGrey};
  }
  .subtext-1 {
    color: ${({ theme }: any) => theme.grayLight};

    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
    font-family: "Lato";
  }
  .subtext-2 {
    color: ${({ theme }: any) => theme.gray};

    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
    font-family: "Lato";
  }
  .subContainer-3 {
    display: flex;
    padding-top: 15px;
    gap: 20px;
  }
  .textbox {
    display: flex;
    padding: 10px 0px 1px 0px;
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
    align-self: stretch;
    border-top: 1px solid rgba(199, 211, 225, 0.5);
  }
  .bluetextbox {
    color: ${({ theme }: any) => theme.primaryBlue};
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
  }
  .imgContainer {
    position: relative;
    width: 50px;
    height: 50px;
    border-radius: 8px;
    border: 1px solid ${({ theme }: any) => theme.gray};
    background: url(<path-to-image>) lightgray 50% / cover no-repeat;
  }
  .iconContainer {
    display: flex;
    width: 16px;
    height: 16px;
    padding: 4px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    position: absolute;
    left: 15px;
    top: 16px;
    border-radius: 100px;
    background: rgba(255, 255, 255, 0.9);
  }

  .btn {
    display: flex;
    padding: 15px 33px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    width: 24px;
    height: 20px;

    margin: 35px 15px 0px;
    background-color: #164781;
    color: #fff;
  }
  .tabWrapper {
    display: flex;
    border-radius: 20px;
    background-color: ${({ theme }: any) => theme.gray};
    padding: 5px;
    width: fit-content;
    align-items: center;
  }
  .headerText {
    color: ${({ theme }: any) => theme.primaryBlue};
    font-family: Raleway;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 150% */
    text-transform: uppercase;
  }
  .miniIconContainer {
    display: flex;
    width: 16px;
    height: 16px;

    justify-content: center;
    gap: 4px;
    flex-shrink: 0;
    border-radius: 100px;

    background: ${({ theme }: any) => theme.lightRed};
    margin-left: auto;
    cursor: pointer;
  }
  .inputText {
    color: ${({ theme }: any) => theme.gray};
    text-align: center;
    font-family: Mulish;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    padding: 4px 10px;
  }
  //notes
  .subContainer {
    display: flex;
    flex-direction: column;
    margin: 15px;
  }
  .container {
    display: flex;
    padding: 10px 10px 0px 10px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    align-self: stretch;
    border-radius: 10px;
    border: 1px solid ${({ theme }: any) => theme.secondaryGrey};
    margin-bottom: 13px;
  }
  .textContainer {
    color: ${({ theme }: any) => theme.primaryBlue};
    font-family: Inter;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 135%;
  }
  .subTextContainer {
    display: flex;
    padding: 10px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    align-self: stretch;
    border-radius: 10px;
    margin-left: auto;
  }
  .inputContainer {
    display: flex;

    flex-direction: column;
    align-items: center;
    gap: 5px;
    align-self: stretch;
    border-top: 1px solid ${({ theme }: any) => theme.secondaryGrey};
  }
  .subinputContainer {
    margin-right: auto;
    padding: 8px 12px;
    margin-right: auto;
    padding: 8px 12px;
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  .inputContainer-1 {
    color: ${({ theme }: any) => theme.primaryBlue};
    font-family: Raleway;
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 184.615% */
    text-transform: uppercase;
  }

  .inputContainer-3 {
    display: flex;
    padding: 8px 12px;
    align-items: flex-start;
    gap: 8px;
    flex: 1 0 0;
    align-self: stretch;
  }
  .textBox {
    display: flex;
    padding: 8px 12px;
    align-items: flex-start;
    gap: 8px;
    flex: 1 0 0;
    align-self: stretch;
    border-radius: 10px;
    border: 1px solid rgba(199, 211, 225, 0.5);
    background: ${({ theme }: any) => theme.primaryWhite};
  }
  .sendBox {
    display: flex;
    height: 60px;
    padding: 8px 14px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    width: 60px;
    height: 60px;
    border-radius: 10px;
    background: rgb(18, 58, 105);
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
    cursor: pointer;
  }
`;
export const TopWrapper = styled.div`
  background: var(--Primary-Blue01, #052b4a);
  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 0px 233px;
  max-width: 100%;
  min-height: 344px;
  .empty-state {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 230px;
    width: 100%;
    background: #f5f5f5;
    border-radius: 12px;
  }

  .top-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 16px 0px;
  }

  .logo {
    display: flex;
    align-items: center;
  }

  .contact-info {
    display: flex;
    align-items: center;
    gap: 20px;

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: flex-end;
      gap: 10px;
    }
  }

  .contact-item {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #eef1f6;
    font-family: "Inter", sans-serif;
    font-size: 14px;
    font-weight: 500;

    svg {
      flex-shrink: 0;
    }
  }

  .row {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    flex-direction: column;
    gap: 30px;
    margin-top: 20px;

    width: 100%;

    @media (max-width: 900px) {
      flex-wrap: wrap;
      gap: 15px;
    }

    @media (max-width: 600px) {
      flex-direction: column;
      align-items: center;
    }
  }
  .cardWrapper {
    display: flex;
    flex-direction: row;
    gap: 16px;
    flex-wrap: wrap;
    width: 70%;
  }
  .contentWrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 30px;
    h1 {
      color: #eef1f6;
      font-feature-settings: "liga" off, "clig" off;
      font-family: Inter;
      font-size: 36px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px; /* 55.556% */
      span {
        color: #ffeac2;
        font-feature-settings: "liga" off, "clig" off;
        font-family: Inter;
        font-size: 36px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
      }
    }
    h2 {
      display: flex;
      align-items: center;
      gap: 10px;

      color: #fff;
      font-family: "Inter", sans-serif;
      font-size: 28px;
      font-weight: 400;
      line-height: 1.3;
      margin: 0;

      .icon {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 36px;
        height: 36px;
        border: 1px solid rgba(234, 237, 247, 0.8);
        border-radius: 7px;
        background-color: #11314b;
        transition: background 0.3s ease;

        svg {
          width: 20px;
          height: 20px;
          fill: #fff;
        }

        &:hover {
          background-color: #164781;
        }
      }
    }
  }

  .imgWrapper {
    display: flex;
    width: 454px;
    height: 258px;
    padding: 15px;
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
    position: absolute;
    right: 227px;
    top: 86px;
    border-radius: 10px 10px 0 0;
    background: #fff;
    box-shadow: 0 -7px 10px 0 rgba(0, 0, 0, 0.25);
    @media (max-width: 1366px) {
      .data-card {
        min-width: auto;
        max-width: none;
        width: 100%; /* or auto */
      }
    }

    @media (max-width: 900px) {
      top: 197px;
    }

    @media (max-width: 600px) {
      top: 197px;
    }

    .carousel-container {
      display: flex;
      overflow-x: auto;
      gap: 12px;
      scroll-behavior: smooth;
      scrollbar-width: none;
      width: 100%;

      &::-webkit-scrollbar {
        display: none;
      }

      .carousel-image {
        width: 424px;
        height: 230px;
        border-radius: 12px;
        object-fit: cover;
        flex-shrink: 0;
      }
    }

    .scroll-btn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      border-radius: 0 6px 6px 0;
      background: rgba(0, 0, 0, 0.5);

      padding: 6px;
      cursor: pointer;
      z-index: 2;

      &.left {
        left: 15px;
      }

      &.right {
        right: 15px;
        border-radius: 6px 0px 0px 6px;
      }
    }
  }

  .data-card {
    display: flex;
    border-radius: 50px;
    background: #1e405c;
    gap: 16px;
    align-items: flex-start;
    padding: 20px;
    // min-width: 280px;
    // max-width: 280px;
    width: 30%;

    @media (max-width: 1366px) {
      .data-card {
        min-width: auto;
        max-width: none;
        width: 100%; /* or auto */
      }
    }

    @media (max-width: 900px) {
      min-width: auto;
      max-width: none;
      width: 100%;
    }

    @media (max-width: 600px) {
      min-width: auto;
      max-width: none;
      width: 100%;
    }
    .icon {
      margin-bottom: 8px;
      svg {
        width: 24px;
        height: 24px;
      }
    }

    span {
      display: flex;
      flex-direction: column;
      h1 {
        color: #eef1f6;
        font-size: 15px;
        font-weight: 600;
        margin: 0;
      }

      h2 {
        color: #eef1f6;
        font-size: 14px;
        font-weight: 400;
        margin-top: 4px;
      }
    }
  }
`;
export const CustomSelectDropdown = styled(Select)`
  width: 200px;
  min-width: 150px;

  .ant-select-selector {
    color: #090b0e;
    border-radius: 20px;
    border: 1px solid var(--Grey-07, #e5e7e9);
    background: var(--Grey-09, #f9fafb);
    min-width: 100px;
    padding: 0 10px;
  }

  .ant-select-arrow {
    color: #94a2b4;
  }

  .ant-select-selection-item {
    font-weight: 400;
    font-size: 12px;
    display: flex;
    gap: 8px;
    align-items: center;
    font-family: Inter;
  }

  .select-option {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .select-option svg {
    width: 10px;
    height: 10px;
  }
`;

export const StyledHeader = styled.div`
display: flex;
background: #fff;
padding: 0 206px;

.header-wrapper {
display: flex;
align-items: center;
padding: 15px 20px;
gap: 20px;
width: 100%;
min-width: 1200px;
box-shadow: 0 2px 10px rgba(0, 0, 0, 0.02);
border-bottom: 1px solid rgba(148, 162, 180, 0.2);
}

.data-card {
display: flex;
align-items: center;
gap: 10px;
width:50%;
min-width: 297px;
padding-right: 20px;
border-right: 1px solid rgba(199, 211, 225, 0.5);

&:last-child {
border-right: none;
}
}

.icon {
background: #f0f4fa;
border-radius: 50%;
width: 36px;
height: 36px;
display: flex;
align-items: center;
justify-content: center;
}

.details {
display: flex;
flex-direction: column;
gap: 5px;
width:-webkit-fill-available;
&:last-child {

.scrollbtn {
cursor: pointer;
transition: opacity 0.2s ease, cursor 0.2s ease;
border:none;
}

.scrollbtn.disabled {
opacity: 0.4;
cursor: not-allowed;
border:none;
}
}
h1 {
color: #164781;
font-size: 15px;
font-weight: 600;
margin: 0;
font-family: 'Inter', sans-serif;
}

h2 {
color: #3d4c5e;
font-size: 14px;
font-weight: 400;
margin: 0;
font-family: 'Inter', sans-serif;
line-height:normal;
}
}

}
`;
